<template lang='pug'>
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование офиса" : "Добавление офиса"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            :error='errors.has("office_name")'
            :error-messages='errors.first("office_name")'
            v-model='item.office_name'
            label='Название'
          )
        v-flex(xs12)
          s-address-suggest(
            :error='errors.has("address_full")'
            :error-messages='errors.first("address_full")'
            @change='onAddressSuggestChange'
            v-model='item.address_full'
          )
        v-flex(xs12 sm6 md4)
          s-region-picker(
            :error='errors.has("region_code")'
            :errors-messages='errors.first("region_code")'
            v-model='item.region_id'
          )
        v-flex(xs12 sm6 md4)
          v-text-field(
            :error='errors.has("address_city")'
            :error-messages='errors.first("address_city")'
            v-model='item.address_city'
            label='Город'
          )
        v-flex(xs12 sm6 md4)
          s-phone-input(
            :error='errors.has("phone")'
            :error-messages='errors.first("phone")'
            v-model='item.phone'
            label='Телефон'
          )
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.avatar_url'
            v-model='item.avatar'
            label='Фото офиса'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { isObject } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id', 'organizationId'],

  data: () => ({
    item: {
      dadata: {}
    }
  }),

  async created() {
    if (this.id) {
      try {
        this.item = (await this.fetchSingle({ id: this.id })).data
        this.item.dadata = {}
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки офиса')
      }
    } else {
      this.item.organization_id = this.organizationId
    }
  },

  methods: {
    async onSave() {
      let data = this.createFormData()

      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack(`Офис сохранен`)
        this.$router.go(-1)
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    createFormData() {
      let data = new FormData()

      Object.keys(this.item).forEach(key => {
        data.append(
          key,
          isObject(this.item[key])
            ? JSON.stringify(this.item[key])
            : this.item[key]
        )
      })

      data.append('avatar', this.item.avatar)

      return data
    },

    onAddressSuggestChange({ data, value, unrestricted_value }) {
      if (null !== data.city) {
        this.item.address_city = data.city
      }

      Object.assign(this.item, {
        dadata: {
          ...data,
          value,
          unrestricted_value
        },
        address_geo_lon: data.geo_lon,
        address_geo_lat: data.geo_lat,
        address_fias_id: data.fias_id
      })
    },

    ...mapActions('partners/offices', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('partners/offices', ['isLoading'])
  }
}
</script>
